import TextField from "./TextField";
import NumberField from "./NumberFields";
import SelectField from "./SelectField";
import RadioField from "./RadioField";
import CheckboxField from "./CheckboxField";
import FileField from "./FileField";
import LocationField from "./LocationField";

export default function FormField(props) {
  switch (props?.field?.type) {
    case "text":
      return <TextField {...props} />;
    case "number":
      return <NumberField {...props} />;
    case "select":
      return <SelectField {...props} />;
    case "radio":
      return <RadioField {...props} />;
    case "checkbox":
      return <CheckboxField {...props} />;
    case "file":
      return <FileField {...props} />;
    case "location":
      return <LocationField {...props} />;
    case "geolocation":
      return <LocationField {...props} />;
    default:
      return <TextField {...props} />;
  }
}
